<template>
  <div :class="{ invisible: !showTable }">
    <div class="header">
      <h2>Needs Review</h2>
    </div>
    <div class="description">
      The following submissions require your attention and resolution.
    </div>
    <BBDataTable
      class="needsReview"
      :columns="columns"
      :support-add-new="false"
      path-url-api="orders"
      :load-items-fn="onItemsLoaded"
      :default-api-params="{
        _fields: 'statuses,createdAt,note,currentStatus',
        _sort: 'createdAt',
        _order: 'desc',
        _fieldsNoPopulate: 'design.name,design._id',
        _filter: [
          {
            field: 'isDeleted',
            op: '=',
            val: 'false'
          },
          {
            field: 'user',
            op: '=',
            val: userId
          },
          {
            field: 'currentStatus',
            op: '=',
            val: this.orderStatusSubmissionReturned
          }
        ]
      }"
    >
      <template v-slot:customCell="{ props }">
        <div v-if="props.column.field == 'attachments'" class="fileWidth">
          <span v-for="file in props.row.statusAttachmentsNote" :key="file._id">
            <font-awesome-icon
              :id="file._id"
              class="mr-2 fileIcon"
              :icon="icons.file"
              @click="onOpeningUploadedAttachment(file.link)"
            />
            <b-tooltip :target="file._id" triggers="hover" placement="right">
              {{ file.filename }}
            </b-tooltip>
          </span>
        </div>
      </template>
      <template v-slot:customButtons="slotProps">
        <router-link
          :to="{
            name: 'orderReview',
            params: {
              id: slotProps.props.row.design._id,
              orderId: slotProps.props.row._id
            }
          }"
          class="btn btn-link btn-highlight btn-sm d-flex align-items-center ml-1"
          v-if="slotProps.props.row"
        >
          <font-awesome-icon class="mr-2" :icon="icons.eyeIcon" />
          <span class="bb-label">REVIEW</span>
        </router-link>
      </template>
    </BBDataTable>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { faEye, faFile } from '@fortawesome/free-solid-svg-icons'
import { namespace } from 'vuex-class'

const oauthStore = namespace('oauthStore')
const orderStatusStore = namespace('orderStatusStore')

@Component({
  components: {}
})
export default class NeedsReview extends Vue {
  @oauthStore.Getter('userId') userId
  @orderStatusStore.Getter('getStatusById') getOrderStatusById

  icons = {
    eyeIcon: faEye,
    file: faFile
  }

  showTable = false

  onItemsLoaded(rows) {
    if (rows.length > 0) this.showTable = true

    return { rows: rows }
  }

  onOpeningUploadedAttachment(fileLink) {
    window.open(fileLink, '_blank')
  }

  get columns() {
    return [
      {
        label: 'ID',
        field: '_id',
        hidden: true
      },
      {
        label: 'Submission Name',
        field: 'design.name',
        tdClass: 'boldText'
      },
      {
        label: 'Notes',
        field: 'note.note'
      },
      {
        label: 'Attachments',
        field: 'attachments',
        type: 'customCell'
      },
      {
        label: 'Created On',
        field: 'createdAt',
        type: 'date',
        dateInputFormat: 'YYYY-MM-DDTHH:mm:ss.SSS', // expects 2018-03-16T05:29:18.123
        dateOutputFormat: 'MM/DD/YYYY'
      },
      {
        label: 'Actions',
        field: 'actions'
      }
    ]
  }

  imgSubmission = {
    center: true,
    blank: true,
    blankColor: '#bbb',
    height: 50
  }
}
</script>

<style lang="scss" scoped>
.needsReview {
  /deep/ {
    table.vgt-table tbody tr td {
      vertical-align: middle;
    }
  }
}
.fileIcon {
  cursor: pointer;
}
.fileWidth {
  max-width: 130px;
}
.invisible {
  display: none;
}
</style>
